import React, { useEffect } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

export default function PrivateRoute({ children }) {
    const { user, loading, profile } = useAuth()
    const location = useLocation()

    useEffect(() => {
        console.log('🛡️ PrivateRoute Check:', {
            path: location.pathname,
            loading,
            userId: user?.id,
            hasProfile: !!profile,
            role: profile?.role
        })
    }, [location.pathname, loading, user, profile])

    if (loading) {
        return (
            <div className="flex h-screen items-center justify-center bg-gray-50">
                <div className="flex flex-col items-center gap-4">
                    <div className="h-10 w-10 animate-spin rounded-full border-4 border-blue-600 border-t-transparent"></div>
                    <p className="text-gray-500 font-medium">Cargando sesión...</p>
                </div>
            </div>
        )
    }

    if (!user) {
        return <Navigate to="/login" replace state={{ from: location }} />
    }

    return children
}
